// extracted by mini-css-extract-plugin
module.exports = {"o1a4a65x":"o1a4a65x","bex860w":"bex860w","b1szgiyp":"b1szgiyp","fullpage":"fullpage","btmn2gh":"btmn2gh"};